"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingError = void 0;
var ShippingError;
(function (ShippingError) {
    ShippingError[ShippingError["SHIPPING_CONTACT_INVALID"] = 0] = "SHIPPING_CONTACT_INVALID";
    ShippingError[ShippingError["SHIPPING_ADDRESS_UNSERVICEABLE"] = 1] = "SHIPPING_ADDRESS_UNSERVICEABLE";
    ShippingError[ShippingError["SHIPPING_UNKNOWN"] = 2] = "SHIPPING_UNKNOWN";
})(ShippingError = exports.ShippingError || (exports.ShippingError = {}));
// Apple Pay https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentcontact
// export interface ShippingContactApplePay {
//   phoneNumber?: string;
//   emailAddress?: string;
//   givenName?: string;
//   familyName?: string;
//   phoneticGivenName?: string; // supported not in all versions
//   phoneticFamilyName?: string;
//   addressLines?: string[]; // 1-st item - number or street, 2nd item - suit or apartment
//   subLocality?: string; // additional information on city level (neighbourhood)
//   locality?: string; // city
//   postalCode?: string;
//   subAdministrativeArea?: string; // county
//   administrativeArea?: string; // state
//   country?: string;
//   countryCode?: string;
// }
// PayPal https://developer.paypal.com/docs/api/orders/v2/#definition-shipping_detail
// export interface ShippingDetailPaypal {
//   name: {
//     full_name: string;
//   };
//   address: {
//     address_line_1?: string; // number or street
//     address_line_2?: string; // suit or apartment
//     admin_area_1?: string; //  province, state, or ISO-3166-2 subdivision
//     admin_area_2?: string; // city, town, or village
//     postal_code?: string;
//     country_code: string;
//   };
// }
//# sourceMappingURL=Shipping.js.map